import cn from 'classnames';

import { IconButton } from 'components/IconButton/IconButton';

export const AddRefereeCard = ({ onClick = () => {} }) => {
  return (
    <div className="border border-neutral-4 rounded-3xl shadow-sm bg-neutral-1 p-8 flex items-center justify-between">
      <h1 className="title-4">Add referee</h1>
      <IconButton icon="plus" onClick={onClick} />
    </div>
  );
};
